/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Newpatient_Youranimals2Inputs */

const en_newpatient_youranimals2 = /** @type {(inputs: Newpatient_Youranimals2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Your animal`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Your animals`);
	return /** @type {LocalizedString} */ ("newPatient_yourAnimals");
};

const fr_newpatient_youranimals2 = /** @type {(inputs: Newpatient_Youranimals2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Votre animal`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Vos animaux`);
	return /** @type {LocalizedString} */ ("newPatient_yourAnimals");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Your animal" |
* | "other" | "Your animals" |
*
* @param {Newpatient_Youranimals2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_youranimals2 = /** @type {((inputs: Newpatient_Youranimals2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Youranimals2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_youranimals2(inputs)
	return fr_newpatient_youranimals2(inputs)
});
export { newpatient_youranimals2 as "newPatient_yourAnimals" }